import { log } from '@/log'
import { LocationGroupStore } from '@/routing/location-group'
import { Route } from 'vue-router'

export function setLocationGroups(to: Route): void {
  const locationGroups = to.meta ?
    to.meta.locationGroups || [] : []
  log.info('set location groups', { locationGroups })
  LocationGroupStore.getInstance().setGroupList(locationGroups)
}
